<template>
  <td :colspan="width">
    <v-card class="my-4" :class="expansionPanelClass">
      <v-container class="pa-0 text-caption">
        <v-row dense>
          <v-col cols="5">
            <v-container class="pa-0">
              <v-row no-gutters>
                <v-col cols="3" class="font-weight-medium text-right">Manufacturer:</v-col><v-col cols="9" class="pl-2">{{equipment.manufacturer}}</v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="3" class="font-weight-medium text-right">Model #:</v-col><v-col cols="9" class="pl-2">{{equipment.modelNumber}}</v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="3" class="font-weight-medium text-right">Serial #:</v-col><v-col cols="9" class="pl-2">{{equipment.serialNumber}}</v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="6" v-if="equipment.maintenance">
            <v-container class="pa-0">
              <v-row no-gutters>
                <v-col cols="2" class="font-weight-medium">Maintenance:</v-col>
                <v-col cols="9">
                  <template v-if="equipment.maintenance.frequencyUnits==='never' || equipment.maintenance.frequency===0">Never</template>
                  <template v-else>
                    Every {{equipment.maintenance.frequency}} {{equipment.maintenance.frequencyUnits}},
                    next maintenance is {{equipment.maintenance.nextDate | formatDate}}
                  </template>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>{{equipment.maintenance.description}}</v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </td>
</template>

<script>
export default {
  name: 'EquipmentListExpand',
  props: {
    width: {required:true,type:Number},
    equipment: {required:true,type:Object}
  },
  computed: {
    expansionPanelClass() {
      return this.$vuetify.theme.dark ? 'black' : 'blue-grey lighten-5';
    }
  }
}
</script>